var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_781",
    "data-name": "Group 781",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 48.162,
    viewBox: "0 0 177 48.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.498,
    y1: 0.739,
    x2: 0.494,
    y2: 0.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed4715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#f4740c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#fa9605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#fdab01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#ffb300"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(0.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M119.356,15.436c54.921,0,87.9,33.487,87.9,33.487L151.071,48.9l6.324-6.841,1.65-.147a16.2,16.2,0,0,1,1.845-.124c.814-.344-.024-.885-.024-.885h-.984a3.81,3.81,0,0,0-.714-.493l-5.684.025s-6.792-.418-9.892-.615-15.971-.614-15.971-.614l-4.231-3.078,1.3-.148-14.52-10.114-15.33.074,0,0s-.91.393-.984.886c.959,0,1.845.073,1.845.073l3.592.737.212.578L94.035,35.09l-1.7-.025s-.572.608-.443.666c.305.136,3.677,2.092,3.677,2.092v.958l-4.121,5.242-12.328.1s-.541.318.05.688c0,.639-.025,4.183-.025,4.183l-48.7-.025C71.926,11.394,119.356,15.436,119.356,15.436Z",
    transform: "translate(-30.447 -15.309)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1612",
    "data-name": "Rectangle 1612",
    width: 175.257,
    height: 0.479,
    transform: "translate(0.776 47.183)",
    fill: "#fff",
    stroke: "#666",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(0 36.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M30.16,73.106c0-2.572,1.444-3.179,3.871-3.179H37.2c3.833,0,4.33.825,4.307,3.312H38.81V73c0-.632-.461-.814-1.261-.814H34.614c-1.42,0-1.687.668-1.687,1.76v.946c0,1.274.267,1.759,1.54,1.759h2.876c1.214,0,1.577-.12,1.577-1.213h2.693v.826c0,1.478-.534,2.644-3.24,2.644H34.031c-2.427,0-3.871-.606-3.871-3.179Z",
    transform: "translate(-30.16 -69.927)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M49.825,70.072h8.127c2.074,0,2.633,1.033,2.633,2.608v.558c0,1.179-.267,1.868-1.5,2.159v.025c.8.146,1.469.5,1.469,1.941v1.493H57.856V77.8c0-.923-.268-1.225-1.1-1.225H52.518v2.28H49.825Zm2.693,4.319H56.97c.727,0,.995-.291.995-.921v-.292c0-.777-.388-.922-1.237-.922h-4.21Z",
    transform: "translate(-36.751 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M77.445,70.072h4.137l3.045,5.654,3.045-5.654h4.136v8.785h-2.62v-6.31h-.024l-3.531,6.31H83.62l-3.531-6.31h-.024v6.31h-2.62Z",
    transform: "translate(-46.007 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M105.239,70.072h3.505l4.829,8.785h-3l-.838-1.553h-5.459l-.789,1.553h-3.008Zm.048,5.339h3.446l-1.749-3.3Z",
    transform: "translate(-53.728 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M121.607,70.072h8.127c2.074,0,2.632,1.033,2.632,2.608v.558c0,1.179-.267,1.868-1.5,2.159v.025c.8.146,1.469.5,1.469,1.941v1.493h-2.693V77.8c0-.923-.266-1.225-1.1-1.225H124.3v2.28h-2.693Zm2.693,4.319h4.452c.727,0,.995-.291.995-.921v-.292c0-.777-.388-.922-1.237-.922H124.3Z",
    transform: "translate(-60.808 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M140.74,70.072h2.693v8.785H140.74Z",
    transform: "translate(-67.22 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M147.744,70.072h4.173l5.059,6.381H157V70.072h2.693v8.785h-4.173l-5.06-6.381h-.025v6.381h-2.693Z",
    transform: "translate(-69.568 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M168.449,70.072h9.606V72.11h-6.914v1.407h6.551v1.819h-6.551v1.409h7.072v2.112h-9.764Z",
    transform: "translate(-76.507 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M194.349,75.932h2.693c.013.935.39,1.006,1.166,1.006h3.3c.57,0,1.152-.059,1.152-.739,0-.765-.315-.813-3.785-.813-4.052,0-4.511-.485-4.511-2.645,0-1.59.145-2.814,3.541-2.814h3.76c3.106,0,3.4,1.056,3.4,2.595V72.8h-2.692c0-.642-.074-.908-1.31-.908h-2.984c-.606,0-1.019.205-1.019.678,0,.765.326.79,3.214.777,4.185-.012,5.157.244,5.157,2.8,0,2.364-.8,2.754-4.38,2.754h-3.263c-2.451,0-3.433-.461-3.433-2.366Z",
    transform: "translate(-85.187 -69.927)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M213.5,70.072h2.693v5.072c0,1.116.4,1.552,1.5,1.552h2.669c1.1,0,1.5-.436,1.5-1.552V70.072h2.694v5.654c0,2.184-1.128,3.227-3.6,3.227H217.1c-2.475,0-3.6-1.043-3.6-3.227Z",
    transform: "translate(-91.606 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M232.872,70.072h7.341c2.559,0,3.177,1.287,3.177,3.01v.751c0,1.312-.57,2.817-2.475,2.817h-5.349v2.207h-2.694Zm2.694,4.393h4.186a.821.821,0,0,0,.873-.935v-.339c0-.6-.291-.935-1.1-.935h-3.954Z",
    transform: "translate(-98.098 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M250.876,70.072h7.339c2.56,0,3.179,1.287,3.179,3.01v.751c0,1.312-.571,2.817-2.475,2.817h-5.351v2.207h-2.693Zm2.693,4.393h4.186a.821.821,0,0,0,.873-.935v-.339c0-.6-.29-.935-1.1-.935h-3.956Z",
    transform: "translate(-104.131 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M268.88,70.072h2.693V76.6h6.054v2.257H268.88Z",
    transform: "translate(-110.165 -69.976)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M282.471,75.8l-4.864-5.726h3.251l2.96,3.592,2.96-3.592h3.251L285.165,75.8v3.058h-2.694Z",
    transform: "translate(-113.09 -69.976)",
    fill: "#666"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo_square.340c9824c6d9d8650638023206878727.svg";
export { ForwardRef as ReactComponent };